module.exports = __webpack_public_path__ + "img/aizq-w.593aab7d.svg";